// @ts-nocheck
import styled from "@emotion/styled";

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  ${({ wrap }) => (wrap === "true" ? "flex-wrap: wrap;" : "")}
  ${({ flex }) => (flex ? `flex: ${flex};` : "")}
  ${({ align }) => (align ? `align-items: ${align};` : "")}
  ${({ justify }) => (justify ? `justify-content: ${justify};` : "")}
  ${({ theme, margin: { top, bottom, left, right } }) => `
    ${top ? `margin-top: ${theme.spacings[top]};` : ""} 
    ${bottom ? `margin-bottom: ${theme.spacings[bottom]};` : ""}
    ${left ? `margin-left: ${theme.spacings[left]};` : ""} 
    ${right ? `margin-right: ${theme.spacings[right]};` : ""}
  `}
`;
